import styled from "styled-components";
import { getTheme, } from "@bracket/ui/themes";
import { FlexBox, } from "./spacial";
import { getStrataBackgroundColor, } from "./strata";

/** Buttons and all things clickety. */
export const InteractiveElement = styled(FlexBox)<{ $active?: boolean }>`
	align-items: center;
	justify-content: center;
	cursor: pointer;
	user-select: none;
	${({ $active }) => $active && `color: ${getTheme().primary};`}
	${({ $strata }) => $strata !== undefined && `background: ${getStrataBackgroundColor($strata)};`}
`;
